module.exports = __webpack_public_path__ + "img/refer-a-friend-hero.d6b01d32.png";